import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "セクション一覧")
], -1)
const _hoisted_3 = { class: "d-grid d-md-flex justify-content-md-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新規登録")
const _hoisted_5 = { class: "table table-hover table-bordered" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"min-width":"60px"}
    }, "種別"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "質問"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"60px"}
    }, "編集"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"140px"}
    }, "質問・手続き")
  ])
], -1)
const _hoisted_7 = { class: "d-grid gap-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("質問一覧")
const _hoisted_9 = { class: "d-grid d-md-flex justify-content-md-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("戻る")

import { inject, ref } from 'vue'
import ConciergeHeaderQuestion from "@/components/parts/ConciergeHeaderQuestion.vue"
import {injectKey, Nicotto, ConciergeSection, ConciergeCategory} from '@/plugins/nicotto'
import IconPenToSquare from '@/components/ui/IconPenToSquare.vue'
import ButtonLink from "@/components/ui/ButtonLink.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  props: {
    categoryId: null
  },
  setup(__props: any) {

const props = __props as {
  categoryId: string
}


const nicotto = inject(injectKey) as Nicotto
const sections = ref<ConciergeSection[]>([])
const category = ref<ConciergeCategory>()
nicotto.concierge.getSectionList(props.categoryId)
    .then(data => {
      sections.value = data
    })
nicotto.concierge.getCategory(props.categoryId)
    .then(data => {
      category.value = data
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (category.value)
      ? (_openBlock(), _createBlock(ConciergeHeaderQuestion, {
          key: 0,
          category: category.value
        }, null, 8, ["category"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ButtonLink, {
        to: `/concierge/categories/${props.categoryId}/sections/new`,
        class: "btn-primary mx-2 mb-2"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("table", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (section) => {
          return (_openBlock(), _createElementBlock("tr", { key: section }, [
            _createElementVNode("td", null, _toDisplayString(section.name), 1),
            _createElementVNode("td", null, _toDisplayString(section.question), 1),
            _createElementVNode("td", null, [
              _createVNode(ButtonLink, {
                class: "btn-primary",
                to: `/concierge/categories/${section.categoryId}/sections/${section.sectionId}`,
                title: "編集"
              }, {
                default: _withCtx(() => [
                  _createVNode(IconPenToSquare)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(ButtonLink, {
                to: `/concierge/categories/${section.categoryId}/sections/${section.sectionId}/questions`,
                class: "btn-success"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(ButtonLink, {
        to: "/concierge/categories",
        class: "btn-secondary mx-2 mb-2"
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}
}

})